/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OralExamRunStateResponseStartAuthority =
  (typeof OralExamRunStateResponseStartAuthority)[keyof typeof OralExamRunStateResponseStartAuthority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamRunStateResponseStartAuthority = {
  lecturer: 'lecturer',
  self_service: 'self_service',
} as const;
